import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { UncontrolledTooltip } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import uuid from 'react-uuid';
import { capitalizeString } from '../../helpers/capitalizeString';
import loginIcon from '../../assets/img/icons/login-primary.svg';
import RouterPaths from '../../constants/RouterPaths';
import { SET_DEALER_SEARCH_STATE } from '../../dealers/DealersReducer';

function LocationsTableRow({ item }) {
  const tooltipId = useMemo(() => `tooltip-${uuid()}`, []);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { city, usersCount, usersPercentage } = item;

  const handleButtonClick = () => {
    dispatch({
      type: SET_DEALER_SEARCH_STATE,
      payload: {
        searchParams: {
          offset: 0,
          city,
        },
      },
    });
    navigate(RouterPaths.DEALERS);
  };

  return (
    <>
      <td className="cropped-row-cell">{capitalizeString(city)}</td>
      <td className="cropped-row-cell">{usersCount || 0}</td>
      <td className="cropped-row-cell">{usersPercentage || 0}%</td>
      <td className="cropped-row-cell">
        <Button
          id={tooltipId}
          className="btn-icon rounded-circle btn-ghost-light"
          size="sm"
          type="button"
          onClick={handleButtonClick}
        >
          <img
            src={loginIcon}
            alt="Show users icon"
            style={{ padding: '10px 10px 15px 10px' }}
          />
        </Button>
        <UncontrolledTooltip className="uncontrolled-tooltip" delay={0} target={tooltipId}>
          Show Users
        </UncontrolledTooltip>
      </td>
    </>
  );
}

LocationsTableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default LocationsTableRow;
